import request from './request'
import { Options, ReqCfg } from './types/api'
import { isObject, stringify } from './utils'

export const get = <T>(
    url: string,
    data?: object,
    config?: ReqCfg,
    apiOptions: Options = {}
): Promise<T> => {
    return request({
        method: 'get',
        url,
        ...config,
        params: {
            ...data
        }
    }, apiOptions)
}

export const post = <T>(
    url: string,
    data?: object,
    config?: ReqCfg,
    apiOptions: Options = {}
): Promise<T> => {
    return request({
        method: 'post',
        url,
        ...config,
        data
    }, apiOptions)
}

export const del = <T>(
    url: string,
    data?: object,
    config?: ReqCfg,
    apiOptions: Options = {}
): Promise<T> => {
    return request({
        method: 'delete',
        url,
        ...config,
        data
    }, apiOptions)
}

export const put = <T>(
    url: string,
    data?: object,
    config?: ReqCfg,
    apiOptions: Options = {}
): Promise<T> => {
    return request({
        method: 'put',
        url,
        ...config,
        data
    }, apiOptions)
}

export const postDd = <T>(
    url: string,
    data?: object,
    config?: ReqCfg,
    apiOptions: Options = {}
): Promise<T> => {
    const headers = config?.headers || {}
    headers['Content-Type'] = 'application/x-www-form-urlencoded'

    let query = data
    if (isObject(data)) {
        query = stringify(data) as any
    }

    return request({
        method: 'post',
        url,
        ...config,
        data: query
    }, apiOptions)
}

export const postMf = <T>(
    url: string,
    data?: object | any,
    config?: ReqCfg,
    apiOptions: Options = {}
): Promise<T> => {
    const headers = config?.headers || {}
    headers['Content-Type'] = 'multipart/form-data'

    let formData: FormData = data
    if (isObject(data) && !(data instanceof FormData)) {
        formData = new FormData()
        Object.keys(data).forEach(key => formData.append(key, data[key]))
    }
    return request({
        method: 'post',
        url,
        ...config,
        data: formData
    }, apiOptions)
}

export const url = <T>(
    url: string,
    data?: object | any
): string => {
    return Object.entries(data).reduce((acc, [key, value]) => {
        return `${acc}${acc.includes('?') ? '&' : '?'}${key}=${value}`
    }, url)
}